import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonLoadingIndicatorComponent } from './button-loading-indicator.component';

@NgModule({
    imports: [CommonModule],
    declarations: [ButtonLoadingIndicatorComponent],
    exports: [ButtonLoadingIndicatorComponent]
})
export class ButtonLoadingIndicatorModule {

}
